/* eslint-disable */
console.debug('gql api: ', __GRAPHQL_API__);
console.debug('gql ws api: ', __GRAPHQL_WS_API__);

export const SENTRY_LOGGING = __SENTRY_LOGGING__ === 'true';
export const SENTRY_RELEASE = __SENTRY_RELEASE__;
export const IFRAME_HOST = __IFRAME_HOST__;
export const IFRAME_URL = __IFRAME_URL__;
export const STAGE = process.env.STAGE;

// opus1.io account appID
export const INTERCOM_APP_ID = 'd1hauhhf';

export const uri = __GRAPHQL_API__ || 'http://localhost:9000/graphql';
export const inProduction = process.env.STAGE === 'prod';
export const wsUri = __GRAPHQL_WS_API__ || 'ws://localhost:8888/graphql';

export const IFRAME_ALLOWED_DOMAIN = __IFRAME_ALLOWED_DOMAIN__;
export const ALLOWED_ORIGIN_DOMAIN = __IFRAME_ALLOWED_DOMAIN__;
export const STRIPE_OAUTH_CLIENT_ID =
    process.env.STRIPE_OAUTH_CLIENT_ID || 'ca_T7YfrjOlXf5cUrTCrFj0BZkQs63tfanQ';

export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const WEB_PUSH_PUBLIC_KEY = process.env.WEB_PUSH_PUBLIC_KEY;

export const S3_IMAGE_BUCKET = __S3_IMAGE_BUCKET__;
export const PENDO_API_KEY = process.env.PENDO_API_KEY;
export const AWS_WAF_CAPTCHA_API_KEY = process.env.AWS_WAF_CAPTCHA_API_KEY;

export const PUBLIC_S3_URL = 'https://s3.amazonaws.com';
export const S3_FILES_BUCKET = __S3_IMAGE_BUCKET__;
export const S3_VOIP_BUCKET = __S3_VOIP_BUCKET__;
/* eslint-enable */
